export default "__VITE_ASSET__C9f48rx3__"